<template>
  <div class="accreditation-details-layout">
    <main class="accreditation-details-main-column">
      <slot name="main" />
    </main>
    <aside class="accreditation-details-side-column">
      <slot name="sidebar" />
    </aside>
  </div>
</template>

<script>
export default {
  name: 'accreditation-details-layout',
}
</script>

<style scoped>
.accreditation-details-layout {
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 448px), 1fr));
  max-width: 1138px;
  min-width: 0;
  width: 100%;
}

.accreditation-details-main-column,
.accreditation-details-side-column {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.accreditation-details-main-column {
  min-width: 0;
}

.accreditation-details-side-column {
  min-width: 0;
}

@media (max-width: 1100px) {
  .accreditation-details-layout {
    grid-template-columns: 1fr;
    max-width: none;
    width: 100%;
  }

  .accreditation-details-main-column,
  .accreditation-details-side-column {
    max-width: none;
  }
}

@media (max-width: 800px) {
  .accreditation-details-layout {
    gap: 16px;
  }
}
</style>
